<template>
    <div class="empleados">
        <h2 class="subheading grey--text">Registro de Proveedor</h2>
        <v-container class="my-0">
            <!--     Dialog Mostrar Erorores del Celular     -->
            <v-dialog v-model="dialog_cellphone" persistent max-width="290">
                <v-card>
                    <v-card-title class="headline">{{$t('aviso')}}</v-card-title>
                    <v-card-text>{{$t('cellphone_wrong')}}</v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="primary" flat @click="dialog_cellphone = false">{{$t('aceptar')}}</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
            <v-dialog
                    v-model="dialog_bloqueo"
                    persistent
                    width="500"
            >
                <v-card class="elevation-0">
                    <v-toolbar class="mb-0" dark color="warning">
                        <v-toolbar-title>
                            {{$t('aviso')}}
                        </v-toolbar-title>
                        <v-spacer></v-spacer>
                    </v-toolbar>
                    <v-card-text>
                        <h2>{{$t('pagina_caduca')}}</h2>
                    </v-card-text>
                </v-card>
            </v-dialog>
            <!--     Diálogo Modal Persistente para Recortar la Imagen Identificacón Oficial Frontal      -->
            <v-dialog v-model="dialog_img_frontal" persistent scrollable max-width="1000px">
                <v-card>
                    <v-toolbar dark color="primary">
                        <v-toolbar-title>
                            {{$t('recortar_imagen')}}
                        </v-toolbar-title>
                    </v-toolbar>
                    <v-card-text>
                        <clipper-fixed
                                ref="clipper"
                                :rotate="degrees"
                                :ratio="ratio"
                                :src="imageIneFrenteURL">
                        </clipper-fixed>
                    </v-card-text>
                    <v-card-actions class="justify-center">
                        <v-layout row wrap class="justify-center">
                            <v-flex xs12>
                                <v-radio-group
                                        v-model="ratio"
                                        name="ratio"
                                        row
                                        label="Ratio"
                                        :mandatory="false"
                                >
                                    <v-radio label="1:1" :value="1"></v-radio>
                                    <v-radio label="3:2" :value="1.5"></v-radio>
                                    <v-radio label="4:3" :value="1.3333333333333333"></v-radio>
                                    <v-radio label="16:9" :value="1.7777777777777777"></v-radio>
                                </v-radio-group>
                            </v-flex>
                            <v-flex xs12>
                                <v-slider
                                        v-model="degrees"
                                        :label="$t('grados')"
                                        step="1"
                                        max="180"
                                        min="-180"
                                        thumb-label="always"
                                ></v-slider>
                            </v-flex>
                            <v-btn
                                    color="primary"
                                    @click="get_image_recortada()"
                            >{{$t('recortar')}}</v-btn>
                        </v-layout>
                    </v-card-actions>
                </v-card>
            </v-dialog>
            <!--     Diálogo Modal Persistente para Recortar la Imagen Identificacón Oficial Atrás      -->
            <v-dialog v-model="dialog_img_atras" persistent scrollable max-width="1000px">
                <v-card>
                    <v-toolbar dark color="primary">
                        <v-toolbar-title>
                            {{$t('recortar_imagen')}}
                        </v-toolbar-title>
                    </v-toolbar>
                    <v-card-text class="justify-center">
                        <clipper-fixed
                                ref="clipper2"
                                :rotate="degrees"
                                :ratio="ratio"
                                :src="imageIneAtrasURL">
                        </clipper-fixed>
                    </v-card-text>
                    <v-card-actions class="justify-center">
                        <v-layout row wrap class="justify-center">
                            <v-flex xs12>
                                <v-radio-group
                                        v-model="ratio"
                                        name="ratio"
                                        row
                                        label="Ratio"
                                        :mandatory="false"
                                >
                                    <v-radio label="1:1" :value="1"></v-radio>
                                    <v-radio label="3:2" :value="1.5"></v-radio>
                                    <v-radio label="4:3" :value="1.3333333333333333"></v-radio>
                                    <v-radio label="16:9" :value="1.7777777777777777"></v-radio>
                                </v-radio-group>
                            </v-flex>
                            <v-flex xs12>
                                <v-slider
                                        v-model="degrees"
                                        :label="$t('grados')"
                                        step="1"
                                        max="180"
                                        min="-180"
                                        thumb-label="always"
                                ></v-slider>
                            </v-flex>
                            <v-btn
                                    color="primary"
                                    @click="dialog_img_atras = false, get_image_recortada_atras()"
                            >{{$t('recortar')}}</v-btn>
                        </v-layout>
                    </v-card-actions>
                </v-card>
            </v-dialog>
            <!--     Diálogo Modal Persistente para Recortar la Foto de perfil      -->
            <v-dialog v-model="dialog_img_perfil" persistent scrollable max-width="1000px">
                <v-card>
                    <v-toolbar dark color="primary">
                        <v-toolbar-title>
                            {{$t('recortar_imagen')}}
                        </v-toolbar-title>
                    </v-toolbar>
                    <v-card-text>
                        <clipper-fixed
                                class="basic lg"
                                :src="imagePerfilURL"
                                ref="clipper3"
                                :rotate="degrees"
                                :round="true"
                                preview="preview">
                        </clipper-fixed>
                    </v-card-text>
                    <v-card-actions class="justify-center">
                        <v-layout row wrap class="justify-center">
                            <v-flex xs12>
                                <v-slider
                                        v-model="degrees"
                                        :label="$t('grados')"
                                        step="1"
                                        max="180"
                                        min="-180"
                                        thumb-label="always"
                                ></v-slider>
                            </v-flex>
                            <v-btn
                                    color="primary"
                                    @click="get_image_recortada_perfil()"
                            >{{$t('recortar')}}</v-btn>
                        </v-layout>
                    </v-card-actions>
                </v-card>
            </v-dialog>
            <!--     Diálogo Modal Persistente para Recortar la Imagen del Logo      -->
            <v-dialog v-model="dialog_img_logo" persistent scrollable max-width="1000px">
                <v-card>
                    <v-toolbar dark color="primary">
                        <v-toolbar-title>
                            {{$t('recortar_imagen')}}
                        </v-toolbar-title>
                    </v-toolbar>
                    <v-card-text>
                        <clipper-basic
                                mode="normal"
                                class="basic lg"
                                ref="clipper4"
                                :src="imageLogoURL">
                        </clipper-basic>
                    </v-card-text>
                    <v-card-actions class="justify-center">
                        <v-btn
                                color="primary"
                                @click="dialog_img_logo = false, get_image_recortada_logo()"
                        >{{$t('recortar')}}</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
            <v-dialog v-model="faceComparisonDialog" width="500" persistent>
                <v-card>
                    <v-toolbar color="primary" dark flat>
                        <v-toolbar-title>Validación de Rostro</v-toolbar-title>
                        <v-spacer></v-spacer>
                        <v-btn icon @click="faceComparisonDialog = false" :disabled="faceComparisonLoading">
                            <v-icon>close</v-icon>
                        </v-btn>
                    </v-toolbar>
                    <v-card-text class="pt-4">
                        <div v-if="faceModalState === 'loading'" class="text-xs-center">
                            <v-progress-circular indeterminate color="primary" size="60" class="mb-4"></v-progress-circular>
                            <p class="headline mb-4">Analizando fotos...</p>
                            <v-alert :value="true" type="info" outline class="mb-4">
                                Mientras procesamos, recuerda que la validación funciona mejor con:
                            </v-alert>
                            <div class="text-xs-left">
                                <p><strong>✓ Iluminación:</strong> Buena iluminación uniforme sin sombras fuertes</p>
                                <p><strong>✓ Ángulo:</strong> Tu rostro de frente a la cámara, cabeza recta</p>
                                <p><strong>✓ Calidad:</strong> Imágenes claras y bien enfocadas, no borrosas</p>
                                <p><strong>✓ Documento:</strong> INE claro y legible, completamente visible</p>
                            </div>
                        </div>
                        <div v-else-if="faceModalState === 'error'">
                            <v-alert :value="true" type="error" outline class="mb-4">
                                <strong>Error en la validación:</strong><br>
                                {{faceComparisonError}}
                            </v-alert>
                            <v-btn color="primary" @click="faceComparisonDialog = false" block>
                                Entendido
                            </v-btn>
                        </div>
                        <div v-else-if="faceModalState === 'success'">
                            <v-alert :value="true" type="success" outline class="mb-4">
                                <v-icon color="success" class="mr-2">check_circle</v-icon>
                                <strong>¡Validación Exitosa!</strong>
                            </v-alert>
                            <v-card class="mb-4">
                                <v-card-text>
                                    <p><strong>Confianza:</strong> {{ faceComparisonResult.confidence.toFixed(1) }}%</p>
                                    <p><strong>Nivel:</strong> {{ faceComparisonResult.confidence_text }}</p>
                                    <p><strong>Calidad INE:</strong> {{ faceComparisonResult.id_face_quality.toFixed(1) }}%</p>
                                    <p><strong>Calidad Selfie:</strong> {{ faceComparisonResult.profile_face_quality.toFixed(1) }}%</p>
                                </v-card-text>
                            </v-card>
                            <v-btn color="primary" @click="faceComparisonDialog = false" block>
                                Continuar
                            </v-btn>
                        </div>
                        <div v-else-if="faceModalState === 'no-match'">
                            <v-alert :value="true" type="warning" outline class="mb-4">
                                <v-icon color="warning" class="mr-2">warning</v-icon>
                                <strong>Las fotos no coinciden</strong>
                            </v-alert>
                            <p class="mb-4">Las imágenes no parecen ser de la misma persona. Por favor:</p>
                            <ul class="mb-4">
                                <li>Verifica que la foto del INE sea clara y legible</li>
                                <li>Toma un nuevo selfie de frente con buena iluminación</li>
                                <li>Asegúrate de que tu rostro sea claramente visible en ambas fotos</li>
                            </ul>
                            <v-btn color="primary" @click="faceComparisonDialog = false" block>
                                Intentar de Nuevo
                            </v-btn>
                        </div>
                        <div v-else class="text-xs-center">
                            <p class="grey--text">Iniciando...</p>
                        </div>
                    </v-card-text>
                </v-card>
            </v-dialog>
            <v-card>
                <v-toolbar
                        class="mb-0"
                        dark
                        color="primary"
                >
                    <v-toolbar-title>
                        <v-icon
                                right
                                dark
                        >
                            airport_shuttle
                        </v-icon>
                        {{currentTitle}}
                    </v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-avatar
                            color="primary lighten-2"
                            class="subheading white--text align-self-center"
                            size="60"
                            v-text="$t('paso') + ' ' +  step + '/2'"
                    ></v-avatar>
                </v-toolbar>
                <v-card-actions>
                    <!--<v-btn-->
                            <!--:hidden="step === 1 || step === 2 "-->
                            <!--color="primary"-->
                            <!--depressed-->
                            <!--@click="step&#45;&#45;"-->
                    <!--&gt;-->
                        <!--<v-icon left>arrow_back</v-icon>-->
                        <!--{{$t('reverso')}}-->
                    <!--</v-btn>-->
                    <v-spacer></v-spacer>
                    <v-btn
                            v-if="step === 1"
                            color="primary"
                            depressed
                            @click="update_data_supplier()"
                    >
                        {{$t('continuar')}}
                        <v-icon right>arrow_forward</v-icon>
                    </v-btn>
                </v-card-actions>
                <v-divider></v-divider>
                <v-window
                        v-model="step"
                >
                    <v-window-item :value="1">
                        <v-layout align-center justify-center>
                            <v-card
                                    class="mb-5"
                                    width="800"
                            >
                                <div class="align-center justify-center">
                                    <p class="align-center justify-center">
                                        {{$t('msg_proveedor_correcto')}}
                                    </p>
                                </div>
                                <v-form
                                        class="mb-4"
                                        @submit.prevent="alta_administrador()">
                                    <v-text-field
                                            box
                                            class="pt-2 pb-2 pl-2 pr-2"
                                            v-model="first_name"
                                            autofocus
                                            prepend-inner-icon="person"
                                            name="first_name"
                                            :label="$t('Nombre')"
                                            :error-messages="errores.first_name"
                                    >
                                    </v-text-field>
                                    <v-text-field
                                            box
                                            class="pt-2 pb-2 pl-2 pr-2"
                                            v-model="last_name"
                                            value="2345345"
                                            prepend-inner-icon="person_outline"
                                            name="last_name"
                                            :label="$t('Apellido')"
                                            :error-messages="errores.last_name"
                                    >
                                    </v-text-field>
<!--                                    <v-text-field-->
<!--                                            box-->
<!--                                            class="pt-2 pb-2 pl-2 pr-2"-->
<!--                                            v-model="celular"-->
<!--                                            prepend-inner-icon="phone_iphone"-->
<!--                                            name="celular"-->
<!--                                            :label="$t('celular')"-->
<!--                                            placeholder="(000) 000 - 0000"-->
<!--                                            mask="phone"-->
<!--                                            :error-messages="errores.celular"-->
<!--                                    >-->
<!--                                    </v-text-field>-->
                                    <vue-phone-number-input
                                            default-country-code="MX"
                                            color="#D32F2F"
                                            valid-color="#2196F3"
                                            @update="onChange"
                                            v-model="celular"
                                            :translations="custom_cell_phone"
                                    >
                                    </vue-phone-number-input>
                                    <br>
                                    <v-layout row wrap class="text-xs-center">
                                        <v-flex xs12 sm6 class="ingla pt-3 pb-3 pl-3 pr-3">
                                            <v-label>
                                                {{$t('foto_ine')}}<br>[{{$t('frente')}}]
                                            </v-label>
                                            <br>
                                            <v-img
                                                    class="pt-3 pb-3"
                                                    :src="resultIneFrenteURL"
                                                    v-if="resultIneFrenteURL"
                                                    width="auto"
                                                    height="180"
                                            ></v-img>
                                            <br>
                                            <v-alert
                                                    :value="errores.ine_frente"
                                                    type="error"
                                                    outline
                                                    transition="scale-transition"
                                            >
                                                {{errores.ine_frente}}
                                            </v-alert>
                                            <br>
                                            <v-btn
                                                    color="primary">
                                                <clipper-upload
                                                        @input="dialog_img_frontal = true, degrees = 0, ratio = 1"
                                                        accept="image/*"
                                                        v-model="imageIneFrenteURL"
                                                >
                                                    {{$t('subir_imagen')}}
                                                </clipper-upload>
                                            </v-btn>
                                        </v-flex>
                                        <v-flex xs12 sm6 class="ingla pt-3 pb-3 pl-3 pr-3">
                                            <v-label>
                                                {{$t('foto_ine')}}<br>[{{$t('atras')}}]
                                            </v-label>
                                            <br>
                                            <v-img
                                                    class="pt-3 pb-3"
                                                    :src="resultIneAtrasURL"
                                                    v-if="resultIneAtrasURL"
                                                    width="auto"
                                                    height="180"
                                            ></v-img>
                                            <br>
                                            <v-alert
                                                    :value="errores.ine_atras"
                                                    type="error"
                                                    outline
                                                    transition="scale-transition"
                                            >
                                                {{errores.ine_atras}}
                                            </v-alert>
                                            <br>
                                            <v-btn
                                                    color="primary">
                                                <clipper-upload
                                                        @input="dialog_img_atras = true, degrees = 0, ratio = 1"
                                                        accept="image/*"
                                                        v-model="imageIneAtrasURL"
                                                >
                                                    {{$t('subir_imagen')}}
                                                </clipper-upload>
                                            </v-btn>
                                        </v-flex>
                                    </v-layout>
                                    <v-layout row wrap class="text-xs-center">
                                        <v-flex xs12 sm6 class="ingla pt-3 pb-3 pl-3 pr-3">
                                            <v-label>
                                                {{$t('foto_perfil')}}
                                            </v-label>
                                            <br>
                                            <v-img
                                                    class="pt-3 pb-3"
                                                    :src="resultPerfilURL"
                                                    v-if="resultPerfilURL"
                                                    width="auto"
                                                    height="180"
                                            ></v-img>
                                            <br>
                                            <v-alert
                                                    :value="errores.avatar"
                                                    type="error"
                                                    outline
                                                    transition="scale-transition"
                                            >
                                                {{errores.avatar}}
                                            </v-alert>
                                            <br>
                                            <v-btn
                                                    color="primary">
                                                <clipper-upload
                                                        @input="dialog_img_perfil = true, degrees = 0, ratio = 1"
                                                        accept="image/*"
                                                        v-model="imagePerfilURL"
                                                >
                                                    {{$t('subir_imagen')}}
                                                </clipper-upload>
                                            </v-btn>
                                        </v-flex>
                                    </v-layout>
                                    <v-layout row wrap>
                                        <v-flex xs12 class="mt-3 mb-3">
                                            <v-btn
                                                :disabled="!resultIneFrenteURL || !resultPerfilURL"
                                                color="primary"
                                                @click="openFaceComparisonModal()"
                                                block
                                            >
                                                Validar Rostro
                                            </v-btn>
                                        </v-flex>
                                    </v-layout>
                                </v-form>
                            </v-card>
                        </v-layout>
                    </v-window-item>
                    <v-window-item :value="2">
                        <v-layout align-center justify-center class="text-sm-center">
                            <v-card
                                    class="mb-0"
                                    width="1000"
                            >
                                <v-form
                                        class="mb-4"
                                        @submit.prevent="alta_empresa()"
                                >
                                    <v-layout row wrap>
                                        <v-flex xs12 sm6>
                                            <v-text-field
                                                    box
                                                    class="pt-2 pb-2 pl-2 pr-2"
                                                    v-model="name"
                                                    autofocus
                                                    prepend-inner-icon="business"
                                                    name="name"
                                                    :label="$t('company_name')"
                                                    :error-messages="errores.name"
                                            >
                                            </v-text-field>
                                        </v-flex>
                                        <v-flex xs12 sm6>
                                            <v-text-field
                                                    box
                                                    class="pt-2 pb-2 pl-2 pr-2"
                                                    v-model="companyAddress"
                                                    prepend-inner-icon="location_on"
                                                    name="companyAddress"
                                                    :label="$t('direccion')"
                                                    :error-messages="errores.companyAddress"
                                            >
                                            </v-text-field>
                                        </v-flex>
                                    </v-layout>
                                    <v-layout row wrap>
                                        <v-flex xs12 sm6>
                                            <v-text-field
                                                    box
                                                    class="pt-2 pb-2 pl-2 pr-2"
                                                    v-model="telephone"
                                                    prepend-inner-icon="phone"
                                                    name="telephone"
                                                    :label="$t('telefono')"
                                                    :error-messages="errores.telephone"
                                            >
                                            </v-text-field>
                                        </v-flex>
                                        <v-flex xs12 sm6>
                                            <v-text-field
                                                    box
                                                    class="pt-2 pb-2 pl-2 pr-2"
                                                    v-model="companyWebPage"
                                                    prepend-inner-icon="public"
                                                    name="companyWebPage"
                                                    :label="$t('pagina_web')"
                                                    :error-messages="errores.companyWebPage"
                                            ></v-text-field>
                                        </v-flex>
<!--                                        <v-flex xs12 sm6>-->
<!--                                            <v-text-field-->
<!--                                                    box-->
<!--                                                    class="pt-2 pb-2 pl-2 pr-2"-->
<!--                                                    v-model="email"-->
<!--                                                    prepend-inner-icon="email"-->
<!--                                                    name="email"-->
<!--                                                    label="E-Mail"-->
<!--                                                    :error-messages="errores.email"-->
<!--                                            >-->
<!--                                            </v-text-field>-->
<!--                                        </v-flex>-->
                                    </v-layout>
                                    <v-layout row wrap>
                                        <v-flex xs12 sm6>
                                            <v-text-field
                                                    box
                                                    class="pt-2 pb-2 pl-2 pr-2"
                                                    v-model="email"
                                                    prepend-inner-icon="email"
                                                    name="email"
                                                    :label="$t('company_email')"
                                                    :error-messages="errores.email"
                                            >
                                            </v-text-field>
                                        </v-flex>
                                        <v-flex xs12 sm6 class="ingla pt-3 pb-3 pl-3 pr-3">
                                            <v-label>
                                                {{$t('logotipo')}}
                                            </v-label>
                                            <br>
                                            <v-img
                                                    class="pt-3 pb-3"
                                                    :src="resultLogoURL"
                                                    v-if="resultLogoURL"
                                                    width="auto"
                                                    height="180"
                                            ></v-img>
                                            <br>
                                            <v-alert
                                                    :value="errores.companyLogo"
                                                    type="error"
                                                    outline
                                                    transition="scale-transition"
                                            >
                                                {{errores.companyLogo}}
                                            </v-alert>
                                            <br>
                                            <v-btn
                                                    color="primary">
                                                <clipper-upload
                                                        @input="dialog_img_logo = true"
                                                        accept="image/*"
                                                        v-model="imageLogoURL"
                                                >
                                                    {{$t('subir_imagen')}}
                                                </clipper-upload>
                                            </v-btn>
                                        </v-flex>
                                    </v-layout>
<!--                                    <v-layout row wrap>-->
<!--                                        <v-flex xs12 sm6>-->
<!--                                            <v-text-field-->
<!--                                                    box-->
<!--                                                    class="pt-2 pb-2 pl-2 pr-2"-->
<!--                                                    v-model="companyScian"-->
<!--                                                    prepend-inner-icon="looks_4"-->
<!--                                                    name="companyScian"-->
<!--                                                    label="SCIAN"-->
<!--                                                    :error-messages="errores.companyScian"-->
<!--                                            ></v-text-field>-->
<!--                                        </v-flex>-->
<!--                                        <v-flex xs12 sm6>-->
<!--                                            <v-text-field-->
<!--                                                    box-->
<!--                                                    class="pt-2 pb-2 pl-2 pr-2"-->
<!--                                                    v-model="companyClassification"-->
<!--                                                    prepend-inner-icon="class"-->
<!--                                                    name="companyClassification"-->
<!--                                                    :label="$t('clasificacion')"-->
<!--                                                    :error-messages="errores.companyClassification"-->
<!--                                            ></v-text-field>-->
<!--                                        </v-flex>-->
<!--                                    </v-layout>-->
<!--                                    <v-layout row wrap>-->
<!--                                        <v-flex xs12 sm4>-->
<!--                                            <v-text-field-->
<!--                                                    box-->
<!--                                                    class="pt-2 pb-2 pl-2 pr-2"-->
<!--                                                    v-model="companyLatitude"-->
<!--                                                    prepend-inner-icon="my_location"-->
<!--                                                    name="companyLatitude"-->
<!--                                                    :label="$t('latitud')"-->
<!--                                                    :error-messages="errores.companyLatitude"-->
<!--                                            ></v-text-field>-->
<!--                                        </v-flex>-->
<!--                                        <v-flex xs12 sm4>-->
<!--                                            <v-text-field-->
<!--                                                    box-->
<!--                                                    class="pt-2 pb-2 pl-2 pr-2"-->
<!--                                                    v-model="companyLongitude"-->
<!--                                                    prepend-inner-icon="my_location"-->
<!--                                                    name="companyLongitude"-->
<!--                                                    :label="$t('longitud')"-->
<!--                                                    :error-messages="errores.companyLongitude"-->
<!--                                            ></v-text-field>-->
<!--                                        </v-flex>-->
<!--                                        <v-flex xs12 sm4>-->
<!--                                            <v-text-field-->
<!--                                                    box-->
<!--                                                    class="pt-2 pb-2 pl-2 pr-2"-->
<!--                                                    v-model="companyURLMap"-->
<!--                                                    prepend-inner-icon="http"-->
<!--                                                    name="companyURLMap"-->
<!--                                                    :label="$t('url_mapa')"-->
<!--                                                    :error-messages="errores.companyURLMap"-->
<!--                                            ></v-text-field>-->
<!--                                        </v-flex>-->
<!--                                    </v-layout>-->
                                    <v-btn
                                            :loading="loading"
                                            color="primary"
                                            type="submit"
                                    >{{$t('enviar')}}
                                    </v-btn>
                                </v-form>
                            </v-card>
                        </v-layout>
                    </v-window-item>
                </v-window>
                <v-divider></v-divider>
                <v-card-actions>
                    <!--<v-btn-->
                            <!--:hidden="step === 1 || step ===2"-->
                            <!--color="primary"-->
                            <!--depressed-->
                            <!--@click="step&#45;&#45;"-->
                    <!--&gt;-->
                        <!--<v-icon left>arrow_back</v-icon>-->
                        <!--{{$t('reverso')}}-->
                    <!--</v-btn>-->
                    <v-spacer></v-spacer>
                    <v-btn
                            v-if="step === 1"
                            color="primary"
                            depressed
                            @click="update_data_supplier()"
                    >
                        {{$t('continuar')}}
                        <v-icon right>arrow_forward</v-icon>
                    </v-btn>
                </v-card-actions>
            </v-card>

        </v-container>
    </div>
</template>

<script>
    import '@/plugins/axios'
    import store from '@/store'
    import Vue from 'vue'
    import VuejsClipper from 'vuejs-clipper'
    import ClipperFixed from "vuejs-clipper/src/components/clipper-fixed";
    import VuePhoneNumberInput from 'vue-phone-number-input'
    import 'vue-phone-number-input/dist/vue-phone-number-input.css'

    Vue.component('vue-phone-number-input', VuePhoneNumberInput)
    Vue.use(VuejsClipper ,{
        components: {
            clipperBasic: 'clipper-basic',
            clipperFixed: 'clipper-fixed',
            clipperUpload: 'clipper-upload'
        }
    })
    export default {
        name: "form_proveedor",
        data () {
            return {
                step: 1,
                errors: [],
                // Datos de la Empresa
                name: '',
                companyAddress: '',
                telephone: '',
                email: '',
                logo_imageUrl: '',
                companyLogo: '',
                companyWebPage: '',
                // companyScian: '',
                // companyClassification: '',
                // companyLatitude: '',
                // companyLongitude: '',
                // companyURLMap: '',
                dialog: false,
                logo_imageName: '',
                logo_imageFile: '',
                // Datos del Administrador
                errores: [],
                first_name: '',
                last_name: '',
                celular: '',
                supplier_email: '',
                show: false,
                password: '',
                confirm_password: '',
                change_password: '',
                // Datos del Empleado
                first_name_employee: '',
                last_name_employee: '',
                email_employee: '',
                extension_employee: '',
                puede_enviar_employee: '',
                celular_employee: '',
                password_employee: '',
                confirm_password_employee: '',

                resultIneFrenteURL: '',
                imageIneFrenteURL: '',

                resultIneAtrasURL: '',
                imageIneAtrasURL: '',

                resultPerfilURL: '',
                imagePerfilURL: '',

                resultLogoURL: '',
                imageLogoURL: '',

                dialog_img_frontal: false,
                dialog_img_atras: false,
                dialog_img_perfil: false,
                dialog_img_logo: false,

                dialog_bloqueo: false,
                info: '',
                idUserAdminProvider: 0,
                idHost: 0,
                band_continue: false,
                loading: false,
                custom_cell_phone: { },
                band_cellphone: false,
                cellphone_plus_country_code: '',
                dialog_cellphone: false,
                degrees: 0,
                ratio: 1,
                // Facial recognition
                faceComparisonLoading: false,
                faceComparisonResult: null,
                faceComparisonError: null,
                faceComparisonDialog: false,
            }
        },
        beforeUpdate(){
            this.custom_cell_phone ={
                "countrySelectorLabel": this.$t('codigo_pais'),
                "phoneNumberLabel": this.$t('celular'),
                "example": this.$t('ejemplo')
            }
        },
        created: async function(){
            // console.log('PATHHHHH = ', this.$route.params['token'])
            //Obtener los Datos del Invitado
            await this.get_info_admin_supplier()
        },
        computed: {
            currentTitle () {
                switch (this.step) {
                    case 1: return this.$t('manager_data')
                    case 2: return this.$t('campany_data')
                    default: return this.$t('employee_data')
                }
            },
            faceModalState() {
                if (this.faceComparisonLoading) return 'loading';
                if (this.faceComparisonError) return 'error';
                if (this.faceComparisonResult) {
                    if (this.faceComparisonResult.success && this.faceComparisonResult.match) return 'success';
                    return 'no-match';
                }
                return 'idle';
            }
        },
        methods: {
            alta_empresa(){
                this.errores = []

                if (!this.faceComparisonResult || !this.faceComparisonResult.success || !this.faceComparisonResult.match) {
                    this.errores = ['Debes completar exitosamente la validación facial antes de enviar el formulario']
                    return
                }

                this.loading = true
                var bodyFormData = new FormData()
                var file_logo = null

                bodyFormData.set('idUserAdminProvider', this.idUserAdminProvider)
                bodyFormData.set('host', this.idHost)
                bodyFormData.set('name', this.name)
                bodyFormData.set('companyAddress', this.companyAddress)
                bodyFormData.set('telephone', this.telephone)
                bodyFormData.set('email', this.email)
                const newID = this.$uuid.v4()
                if (this.resultLogoURL != '' && this.resultLogoURL.length > 6) {
                    file_logo = this.dataURLtoFile(this.resultLogoURL, 'logo_update' + newID + '.jpeg')
                }
                bodyFormData.append('companyLogo', file_logo)
                bodyFormData.set('companyWebPage', this.companyWebPage)
                bodyFormData.set('companyScian', 1989)
                bodyFormData.set('companyClassification', 'companyClassification')
                bodyFormData.set('companyLatitude', 1989.1989)
                bodyFormData.set('companyLongitude', 1989.1989)
                bodyFormData.set('companyURLMap', 'companyURLMap')
                bodyFormData.set('companyValidity', '1989-09-11')
                bodyFormData.set('id_parque', '')
                const config = {
                    method: 'post',
                    url: 'https://empresa-service.intrare.app/createCompanyProvider',
                    headers: {
                        'Content-Type': 'multipart/form-data',
                        'Accept-Language': this.language
                    },
                    data: bodyFormData
                };
                axios(config)
                    .then(ok => {
                        this.loading = false
                        console.log('Datos del Proveedor dados de Alta Correctamente.')
                        this.$router.push({path: '/registro/proveedor/exito'})
                    })
                    .catch(error => {
                        console.log(error.response.data)
                        if(error.response.status == 400
                            && typeof error.response.data == "object"
                            && error.response.data)
                            this.errores = error.response.data
                        this.loading = false
                    })
            },
            get_info_admin_supplier: async function () {
                console.log('GET INFO NEW ADMIN SUPPLIER')
                const config = {
                    method: 'get',
                    url: 'https://empresa-service.intrare.app/getProvider/' + this.$route.params['token'] + '/',
                    headers: {
                        'Content-Type': 'application/json',
                        'Accept-Language': this.language,
                    },
                };
                axios(config)
                    .then(ok => {
                        this.info = ok.data
                        if(ok.data.length === 0){
                            this.dialog_bloqueo = true
                            console.log('Página Expirada .... overlay = ', this.dialog_bloqueo)
                        }
                        this.fill_fields(ok.data)
                    })
                    .catch(error => {
                        if(error.response && error.response.status == 400
                            && typeof error.response.data == "object"
                            && error.response.data)
                            this.errores = error.response.data
                        else
                        if(error.response.status == 404)
                        {
                            this.$store.commit('snackbar_activate_true')
                            this.$store.commit('snackbar_change_color', 'error')
                            this.$store.commit('snackbar_change_message', 'Token Inválido')
                            setTimeout(this.clear, 3000)
                        }
                    })
                    .finally(() => (this.loading = false))
            },
            update_data_supplier() {
                if (this.band_cellphone === true)
                {
                    this.errores = []
                    var bodyFormData = new FormData()
                    var file1 = null
                    var file2 = null
                    var file3 = null

                    bodyFormData.set('first_name', this.first_name)
                    bodyFormData.set('last_name', this.last_name)
                    bodyFormData.set('celular', this.cellphone_plus_country_code)
                    if (this.resultIneFrenteURL != '' && this.resultIneFrenteURL.length > 6) {
                        file1 = this.dataURLtoFile(this.resultIneFrenteURL, 'ine_front.jpeg')
                    }
                    bodyFormData.append('ine_frente', file1)
                    if (this.resultIneAtrasURL != '' && this.resultIneAtrasURL.length > 6) {
                        file2 = this.dataURLtoFile(this.resultIneAtrasURL, 'ine_back.jpeg')
                    }
                    bodyFormData.append('ine_atras', file2)
                    if (this.resultPerfilURL != '' && this.resultPerfilURL.length > 6) {
                        file3 = this.dataURLtoFile(this.resultPerfilURL, 'avatar.jpeg')
                    }
                    bodyFormData.append('avatar', file3)
                    const config = {
                        method: 'patch',
                        url: 'https://empresa-service.intrare.app/updateProvider/' + this.$route.params['token'] + '/',
                        headers: {
                            'Content-Type': 'application/json',
                            'Accept-Language': this.language,
                        },
                        data: bodyFormData
                    };
                    axios(config)
                        .then(ok => {
                            this.step++
                            this.errores = []
                            console.log('EXITO')
                        })
                        .catch(error => {
                            if(error.response && error.response.status == 400
                                && typeof error.response.data == "object"
                                && error.response.data)
                                this.errores = error.response.data
                        })
                        .finally(() => (console.log('FINALIZADO')))
                } else {
                    this.dialog_cellphone = true
                }
            },
            fill_fields(datos){
                if(datos.length > 0){
                    const providerUser = datos[0]
                    this.first_name = providerUser.first_name
                    this.last_name = providerUser.last_name
                    this.celular = providerUser.celular
                    this.idUserAdminProvider = providerUser.id
                    
                    // Enhanced host extraction
                    let hostRaw = providerUser.host
                    if (!hostRaw && providerUser.profile) {
                         hostRaw = providerUser.profile.host
                    }
                    
                    if (hostRaw && typeof hostRaw === 'object') {
                        this.idHost = hostRaw.id
                    } else {
                        this.idHost = hostRaw
                    }
                    console.log(datos)
                }
            },
            get_current_date: function (){
                var today = new Date();
                var dd = today.getDate();
                var mm = today.getMonth()+1;
                var yyyy = today.getFullYear();

                if(dd<10)
                {
                    dd='0'+dd;
                }

                if(mm<10)
                {
                    mm='0'+mm;
                }
                today = yyyy + '-' + mm + '-' + dd;
                return today
            },
            pickFile_logo(){
                this.$refs.image_logo.click ()
            },
            onFilePicked_logo(e){
                const files = e.target.files
                if(files[0] !== undefined) {
                    this.logo_imageName = files[0].name
                    if(this.logo_imageName.lastIndexOf('.') <= 0) {
                        return
                    }
                    const fr = new FileReader ()
                    fr.readAsDataURL(files[0])
                    fr.addEventListener('load', () => {
                        this.logo_imageUrl = fr.result
                        this.logo_imageFile = files[0] // this is an image file that can be sent to server...
                    })
                } else {
                    this.logo_imageName = ''
                    this.logo_imageFile = ''
                    this.logo_imageUrl = ''
                }
            },
            alta_empleado(){

            },
            get_image_recortada() {
                console.log('Datos de la imagen = ', this.imageIneFrenteURL.size)
                const canvas = this.$refs.clipper.clip();//call component's clip method
                this.resultIneFrenteURL = canvas.toDataURL("image/jpeg", 0.2);//canvas->image
                console.log(this.resultIneFrenteURL)
                this.dialog_img_frontal = false
                this.dialog = true
            },
            get_image_recortada_atras() {
                const canvas = this.$refs.clipper2.clip();//call component's clip method
                this.resultIneAtrasURL = canvas.toDataURL("image/jpeg", 0.2);//canvas->image
                console.log(this.resultIneAtrasURL)
                this.dialog_img_atras = false
                this.dialog = true
            },
            get_image_recortada_perfil() {
                const canvas = this.$refs.clipper3.clip();//call component's clip method
                this.resultPerfilURL = canvas.toDataURL("image/jpeg", 0.2);//canvas->image
                console.log(this.resultPerfilURL)
                this.dialog_img_perfil = false
                this.dialog = true
            },
            get_image_recortada_logo() {
                const canvas = this.$refs.clipper4.clip();//call component's clip method
                this.resultLogoURL = canvas.toDataURL("image/jpeg", 0.3);//canvas->image
                console.log(this.resultLogoURL)
                this.dialog_img_logo = false
                this.dialog = true
            },
            dataURLtoFile(dataurl, filename) {
                var arr = dataurl.split(','), mime = arr[0].match(/:(.*?);/)[1],
                    bstr = atob(arr[1]), n = bstr.length, u8arr = new Uint8Array(n);
                while(n--){
                    u8arr[n] = bstr.charCodeAt(n);
                }
                return new File([u8arr], filename, {type:mime});
            },
            onChange (data) {
                console.log(data)
                this.cellphone_plus_country_code = data.e164
                // console.log(data.formattedNumber)
                // console.log(data.isValid)
                this.band_cellphone = data.isValid
                // Object.assign(this, {
                //   nationalNumber,
                //   countryCode: data.countryCode
                // })
            },
            openFaceComparisonModal() {
                this.faceComparisonLoading = true;
                this.faceComparisonError = null;
                this.faceComparisonResult = null;
                this.faceComparisonDialog = true;
                this.compareFacialRecognition();
            },
            async compareFacialRecognition() {
                this.faceComparisonError = null;
                this.faceComparisonLoading = true;
                this.faceComparisonResult = null;

                try {
                    if (!this.resultIneFrenteURL) {
                        this.faceComparisonError = 'Por favor, sube la foto del INE (frente)';
                        this.faceComparisonLoading = false;
                        return;
                    }

                    if (!this.resultPerfilURL) {
                        this.faceComparisonError = 'Por favor, sube la foto de perfil (selfie)';
                        this.faceComparisonLoading = false;
                        return;
                    }

                    const ineBlob = this.dataURLtoBlob(this.resultIneFrenteURL);
                    const fotoBlob = this.dataURLtoBlob(this.resultPerfilURL);

                    console.log('INE Blob size:', ineBlob.size, 'type:', ineBlob.type);
                    console.log('Foto Blob size:', fotoBlob.size, 'type:', fotoBlob.type);

                    const formData = new FormData();
                    formData.append('id_image', ineBlob, 'ine.jpg');
                    formData.append('profile_image', fotoBlob, 'selfie.jpg');

                    const response = await axios.post(
                        'https://microservices.intrare.app/identification/compare/',
                        formData,
                        {
                            headers: {
                                'Content-Type': 'multipart/form-data',
                                'X-API-Key': '63f6f7729962518de2073625d1e61be17d5f99b5',
                            }
                        }
                    );

                    this.faceComparisonResult = response.data;
                    this.faceComparisonLoading = false;

                    if (!response.data.success) {
                        this.faceComparisonError = response.data.message || 'Error en la comparación facial';
                    }
                } catch (err) {
                    this.faceComparisonLoading = false;
                    console.error('Facial Recognition Error', err);
                    if (err.response && err.response.data) {
                        console.log('Response Data:', err.response.data);
                    }

                    let errorMessage = 'Error al conectar con el servicio';

                    if (err.response && err.response.data) {
                        const data = err.response.data;
                        if (data.message) {
                            errorMessage = data.message;
                        } else if (data.error) {
                            errorMessage = typeof data.error === 'string' ? data.error : data.error.message || 'Error desconocido';
                        } else if (data.detail) {
                            errorMessage = data.detail;
                        } else if (typeof data === 'string') {
                            errorMessage = data;
                        }
                    } else if (err.message) {
                        errorMessage = err.message;
                    }

                    this.faceComparisonError = errorMessage;
                }
            },
            dataURLtoBlob(dataURL) {
                const arr = dataURL.split(',');
                const mime = arr[0].match(/:(.*?);/)[1];
                const bstr = atob(arr[1]);
                let n = bstr.length;
                const u8arr = new Uint8Array(n);
                while (n--) {
                    u8arr[n] = bstr.charCodeAt(n);
                }
                return new Blob([u8arr], { type: mime });
            }
        }
    }
</script>

<style scoped>
    .ingla {
        border-radius: 2px;
        border-color: #002b48 #002b48 #002b48 #002b48;
        border-width: 2px 2px 2px 2px;
        border-style: solid solid solid solid;
    }
</style>
